import React, { useEffect, useState, useRef } from "react";
import {
	BigMenuContainer,
	MenuContainer,
	Dot,
	MenuText,
	Container,
	Percentage,
	Svg,
} from "./style";
import { PALLETE } from "../../configs/configs";

export default function ProgressCircle({
	isWallet = false,
	styleMenuText = {},
	squareEnd = false,
	radius = 120,
	strokeWidth = 10,
	valueArray = [],
	noLegend = false,
}) {
	const [values, setValues] = useState([]);
	const circleRef = useRef(null);
	const [rates, setRates] = useState([]);
	const halfCircle = radius + strokeWidth / 2;
	const circleCircunference = 2 * Math.PI * radius;
	const colorList = [PALLETE.main, PALLETE.blue, PALLETE.orange];

	useEffect(() => {
		if (!valueArray) return;
		setValues(valueArray);
		setRates(valueArray);
		if (isWallet) {
			const arr = valueArray;
			const sort = arr.map((item, i) => {
				switch (i) {
					case 0:
						return {
							...item,
							rate: item.rate + arr[1].rate + arr[2].rate,
						};
					case 1:
						return {
							...item,
							rate: item.rate + arr[2].rate,
						};
					case 2:
						return item;
					default:
						return item;
				}
			});
			setRates(sort);
		}
	}, [valueArray, isWallet]);

	return (
		<Container>
			<Svg
				transform="rotate(-180)"
				width={radius * 2}
				height={radius * 2}
				viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
				radius={radius}
				// style={shadow(radius)}
			>
				{/* {
          Platform.OS === 'android' ? (
            <Defs>
              <RadialGradient
                id="grad"
                cx={halfCircle}
                cy={halfCircle}
                rx={radius}
                ry={radius}
                gradientUnits="userSpaceOnUse"
              >
                <Stop offset="90%" stopColor="black" stopOpacity="0" />
                <Stop offset="92%" stopColor="black" stopOpacity=".2" />
                <Stop offset="1" stopColor="black" stopOpacity="1" />
              </RadialGradient>
            </Defs>
          ) : <></>
        } */}
				<g origin={`${halfCircle}, ${halfCircle}`}>
					{/* CIRCULO CINZA BASE */}
					<circle
						//  style={{ boxShadow: '0px 4px 4px 0px #00000040'}}
						cx="50%"
						cy="50%"
						stroke={"#EEEEEE"}
						strokeWidth={strokeWidth}
						r={radius}
						fill="transparent"
						// fill={Platform.OS === 'android' ? 'url(#grad)' : 'transparent'}
					/>

					{/* CIRCULO DO PRIMEIRO GRÁFICO COM A PONTA QUADRADA */}
					{squareEnd && (
						<circle
							origin={`${halfCircle}, ${halfCircle}`}
							rotation={-3}
							cx="50%"
							cy="50%"
							stroke={valueArray[valueArray.length - 1].color}
							strokeWidth={strokeWidth}
							r={radius}
							fill="transparent"
							strokeDasharray={circleCircunference}
							strokeDashoffset={circleCircunference * 0.99}
						/>
					)}
					{rates.map((item, i) => {
						return (
							<circle
								ref={circleRef}
								key={`circle_${i}`}
								cx="50%"
								cy="50%"
								stroke={item.color}
								strokeWidth={strokeWidth}
								r={radius}
								fill="transparent"
								strokeDasharray={circleCircunference}
								strokeDashoffset={circleCircunference * (1 - item.rate)}
								strokeLinecap="round"
							/>
						);
					})}
				</g>
			</Svg>
			{!noLegend && (
				<BigMenuContainer>
					{!isWallet
						? [...values].reverse().map((item, i) =>
								item.title ? (
									<MenuContainer key={`legend_${i}`}>
										{/* <Dot></Dot> */}
										<Dot backgroundColor={item.color || colorList[i]}></Dot>
										<MenuText style={styleMenuText}>{item.title}</MenuText>
									</MenuContainer>
								) : null,
						  )
						: [...values].reverse().map((item, i) =>
								item.title ? (
									<MenuContainer key={`legend_${i}`}>
										<Percentage color={item.color || colorList[i]}>
											{Math.floor(item.rate * 100)}%
										</Percentage>
										<MenuText style={styleMenuText}>{item.title}</MenuText>
									</MenuContainer>
								) : null,
						  )}
				</BigMenuContainer>
			)}
		</Container>
	);
}
